// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChatListForm_wrapper__1Z1_T","statusWrapper":"ChatListForm_statusWrapper__rngB7","active":"ChatListForm_active__2PG2I"};